























import Vue from 'vue';
import * as Tone from 'tone';
import { mapGetters } from 'vuex';

import Slider from './Slider.vue';

export default Vue.extend({
  name: 'Controls',
  components: {
    Slider
  },
  computed: {
    ...mapGetters(['isPlaying', 'tempo', 'volume'])
  },
  watch: {
    tempo(bpm) {
      Tone.Transport.bpm.value = bpm;
    },
    volume(volume) {
      Tone.Destination.volume.value = volume;
    }
  },
  methods: {
    async togglePlay() {
      await Tone.start();

      this.$store.commit('togglePlay');

      if (this.isPlaying) {
        Tone.Transport.start('+0.1');
        return;
      }

      Tone.Transport.stop();
    }
  }
});
